import {getPriceInCurrency} from '../currency/currencyUtils';

/**
 * Calcula el importe total de un producto solicitado,
 * incluyendo sus modificadores seleccionados.
 *
 * Todos los importes se manejan en centavos.
 */
export const getOrderProductTotalPrice = (
    orderProduct,
    currency,
    exchangeRates
) => {
    if (!orderProduct || !orderProduct.orozcoProduct) {
        return 0;
    }

    const product = orderProduct.orozcoProduct;
    const quantity = Number(orderProduct.quantity) || 0;

    const basePrice = Array.isArray(product.prices) && product.prices.length
        ? getPriceInCurrency(
            product.prices,
            currency,
            exchangeRates
        )
        : 0;

    const modifiers = orderProduct.orozcoProductModifiers || [];

    const modifiersPrice = modifiers.reduce((total, modifier) => {
        if (!modifier || typeof modifier !== 'object' ||
            !Array.isArray(modifier.prices)) {
            throw new Error(
                'No se recibieron los precios de un modificador seleccionado.'
            );
        }

        const price = modifier.prices.length
            ? getPriceInCurrency(modifier.prices, currency, exchangeRates)
            : 0;

        return total + price;
    }, 0);

    return quantity * (basePrice + modifiersPrice);
};
